import { createFeatureSelector, createSelector } from "@ngrx/store";
import { materialFeatureKey } from "./material.reducer";

export const selectMaterialState = createFeatureSelector(materialFeatureKey);

export const selectMaterial = createSelector(
  selectMaterialState,
  (state: any) => state
); 
